export class TransformationNodeDTO {
    name!: string;
    type!: number;
    alwaysArray!: boolean;
    protocolIndex!: number;
    childNodes!: TransformationNodeDTO[];
    function!: string;
    functionResultFormat!: string;
}